/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.img_holder[_ngcontent-%COMP%]{text-align:center}.alert-info[_ngcontent-%COMP%]{color:#fff;background-color:#b98754;border-color:#fff}\n/*# sourceMappingURL=login-component.css.map*/"];
export { styles as styles };
